module Intl.NumberFormat (Locale(..), Currency(..), formatCurrency) where

import Data.Function.Uncurried (Fn3, runFn3)

newtype Locale = Locale String

newtype Currency = Currency String

foreign import formatCurrency_ :: Fn3 Locale Currency Number String

formatCurrency :: Locale -> Currency -> Number -> String
formatCurrency = runFn3 formatCurrency_
